import { getParams, sellerApiClient } from './sellerApiClient';
import { FilterModel } from "@hooks/useFiltersSearchParams";
import { PaginationModel } from "@hooks/usePagingSearchParams";
import { ResponsePages } from "./types";
import { AxiosResponse } from 'axios';

interface AmountWithCurrency {
  amount: number;
  currency: string;
}

export interface TUniClubLevel {
  id: number;
  name: string;
  cashbackPercent: number;
  spentFrom: AmountWithCurrency;
}

export interface TUniClubLevelsResponse {
  levels: TUniClubLevel[],
  currentSpend: AmountWithCurrency;
  currentCashback: AmountWithCurrency;
  lastUpdated: string;
}

export interface TUniClubPaymentsTotal {
  amount: AmountWithCurrency;
}

export interface TUniClubParcelItem {
  id: string;
  name: string;
  quantity: number;
  url: string;
}

export interface TUniClubParcel {
  id: string;
  sellerId: string;
  sellerName: string;
  trackNumber: string;
  externalNumber: string;
  serviceName: string;
  deliveryPrice: AmountWithCurrency;
  cashback: AmountWithCurrency;
  deliveryDate: string;
  cashbackLevelId: number;
  cashbackPercent: number;
  marketplaceType: string;
  items: TUniClubParcelItem[];
}

export interface TUniClubRefs {
  id: string;
  name: string;
  email: string;
  registrationDate: string;
  bonus: AmountWithCurrency;
}

export const getUniClubLevels = async (): Promise<TUniClubLevelsResponse> => {
  const response = await sellerApiClient.get<TUniClubLevelsResponse>(
    '/v1/uni-club/cashback/levels',
  );

  return response.data;
};

export const getUniClubPaymentsTotal = async (): Promise<TUniClubPaymentsTotal> => {
  const response = await sellerApiClient.get<TUniClubPaymentsTotal>(
    '/v1/uni-club/cashback/payments/all-time',
  );

  return response.data;
};

export const getUniClubParcels = async ({ page, filters }: {
  page: PaginationModel;
  filters?: FilterModel[];
}): Promise<ResponsePages<TUniClubParcel>> => {
  const response = await sellerApiClient.get<ResponsePages<TUniClubParcel>>(
    '/v1/uni-club/cashback/parcels/page', {
      params: getParams(page, filters),
      paramsSerializer: { indexes: null },
    }
  );

  return response.data;
};

export const getUniClubRefs = async ({ page, filters }: {
  page: PaginationModel;
  filters?: FilterModel[];
}): Promise<ResponsePages<TUniClubRefs>> => {
  if ("todo") return {
    total: 20,
    items: [
      { id: "5455237", name: "James Harris", email: "james-harris@mail.com", bonus: { amount: 2000, currency: "CNY" }, registrationDate: "2025-10-15T08:43:51.572Z" },
      { id: "5455238", name: "Reginald Farmer", email: "reginald-farmer@mail.com", bonus: { amount: 5000, currency: "CNY" }, registrationDate: "2025-10-15T08:43:51.572Z" },
      { id: "5455239", name: "Angel Washington", email: "angel-washington@mail.com", bonus: { amount: 3000, currency: "CNY" }, registrationDate: "2025-10-15T08:43:51.572Z" },
      { id: "5455240", name: "Thomas Taylor", email: "thomas-taylor@mail.com", bonus: { amount: 500, currency: "CNY" }, registrationDate: "2025-10-15T08:43:51.572Z" },
      { id: "5455241", name: "Richard Green", email: "richard-green@mail.com", bonus: { amount: 30, currency: "CNY" }, registrationDate: "2025-10-15T08:43:51.572Z" },
      { id: "5455242", name: "Daniel Hill", email: "daniel-hill@mail.com", bonus: { amount: 100, currency: "CNY" }, registrationDate: "2025-10-15T08:43:51.572Z" },
      { id: "5455233", name: "James Harris", email: "james-harris@mail.com", bonus: { amount: 2000, currency: "CNY" }, registrationDate: "2025-10-15T08:43:51.572Z" },
      { id: "5455234", name: "Reginald Farmer", email: "reginald-farmer@mail.com", bonus: { amount: 5000, currency: "CNY" }, registrationDate: "2025-10-15T08:43:51.572Z" },
      { id: "5455235", name: "Angel Washington", email: "angel-washington@mail.com", bonus: { amount: 3000, currency: "CNY" }, registrationDate: "2025-10-15T08:43:51.572Z" },
      { id: "5455246", name: "Thomas Taylor", email: "thomas-taylor@mail.com", bonus: { amount: 500, currency: "CNY" }, registrationDate: "2025-10-15T08:43:51.572Z" },
    ]
  }
  const response = await sellerApiClient.get<ResponsePages<TUniClubRefs>>(
    '/v1/uni-club/cashback/refs/page', {
      params: getParams(page, filters),
      paramsSerializer: { indexes: null },
    }
  );

  return response.data;
};

export const getOperationsXLSX = async (): Promise<AxiosResponse> => {
  return await sellerApiClient.get("/v1/uni-club/cashback/parcels/xlsx", {
    responseType: 'blob'
  });
};
